import hangzhouwan from "./index.vue";
import hangzhouwanHome from "./Home.vue";

const ramp = () => import("./ramp.vue");
const emptyComponent = () => import("./emptyRouterComponent.vue");
const gasClampRamp = () => import("./gasClampRamp.vue");
const gasClampNorthChannelNorthTower = ()=>import("./gasClampNorthChannelNorthTower.vue");
const gasClampNorthChannelSouthTower = ()=>import("./gasClampNorthChannelSouthTower.vue");
const gasClampSouthChannelMainTower = ()=>import("./gasClampSouthChannelMainTower.vue");
const airValveNorthChannelNorthTower = ()=>import("./airValveNorthChannelNorthTower.vue");
const airValveNorthChannelSouthTower = ()=>import("./airValveNorthChannelSouthTower.vue");
const airValveSouthChannelMainTower = ()=>import("./airValveSouthChannelMainTower.vue");
const tower = () => import("./tower.vue");
const steelBox = () => import("./steelBox.vue");
const ventilation = () => import("./ventilation.vue");
// const remoteHistory = ()=>import('./../../components/RemoteHistory.vue')
const dataHistory = () => import("./../../components/DataHistory.vue");
const bridgeImg = () => import("./bridgeImg.vue");
const login = () => import("./login.vue");

export default [
  {
    path: "/hangzhouwanIndex",
    name: "hangzhouwanIndex",
    component: hangzhouwanHome
  },
  {
    path: "/hangzhouwan/login",
    name: "hangzhouwanLogin",
    component: login
  },
  {
    path: "/hangzhouwan",
    name: "hangzhouwan",
    redirect: "/hangzhouwan",
    component: hangzhouwan,
    children: [
      {
        path: "gasClamp",
        name: "gasClamp",
        redirect: "/hangzhouwan/gasClamp/ramp",
        component: emptyComponent,
        children: [
          {
            path: "ramp",
            name: "ramp",
            component: gasClampRamp
          },
          {
            path: "northChannelNorthTower",
            name: "northChannelNorthTower",
            component: gasClampNorthChannelNorthTower
          },
          {
            path: "northChannelSouthTower",
            name: "northChannelSouthTower",
            component: gasClampNorthChannelSouthTower
          },
          {
            path: "southChannelMainTower",
            name: "southChannelMainTower",
            component: gasClampSouthChannelMainTower
          },
        ],
      },
      {
        path: "airValve",
        name: "airValve",
        redirect: "/hangzhouwan/airValve/northChannelNorthTower",
        component: emptyComponent,
        children: [
          {
            path: "northChannelNorthTower",
            name: "northChannelNorthTower",
            component: airValveNorthChannelNorthTower
          },
          {
            path: "northChannelSouthTower",
            name: "northChannelSouthTower",
            component: airValveNorthChannelSouthTower
          },
          {
            path: "southChannelMainTower",
            name: "southChannelMainTower",
            component: airValveSouthChannelMainTower
          }
        ],
      },
      {
        path: "dataHistory",
        name: "dataHistory",
        component: dataHistory
      },
      {
        path: "steelBox",
        name: "steelBox",
        redirect: "/hangzhouwan/steelBox/nn1nn2",
        component: emptyComponent,
        children: [
          {
            path: "nn1nn2",
            name: "hangzhouwanSteelBoxNN1NN2",
            component: steelBox
          },
          {
            path: "nn3nn4",
            name: "hangzhouwanSteelBoxNN3NN4",
            component: steelBox
          },
          {
            path: "ns1ns2",
            name: "hangzhouwanSteelBoxNS1NS2",
            component: steelBox
          },
          {
            path: "ns3ns4",
            name: "hangzhouwanSteelBoxNS3NS4",
            component: steelBox
          },
          {
            path: "sn1sn2",
            name: "hangzhouwanSteelBoxSN1SN2",
            component: steelBox
          },
          {
            path: "ss1ss2",
            name: "hangzhouwanSteelBoxSS1SS2",
            component: steelBox
          },
        ]
      },
      {
        path: "tower",
        name: "tower",
        redirect: "/hangzhouwan/tower/northChannelNorthTower",
        component: emptyComponent,
        children: [
          {
            path: "northChannelNorthTower",
            name: "hangzhouwanNCNT",
            component: tower
          },
          {
            path: "northChannelSouthTower",
            name: "hangzhouwanNCST",
            component: tower
          },
          {
            path: "southChannelMainTower",
            name: "hangzhouwanSCMT",
            component: tower
          }
        ]
      },
      {
        path: "ventilation",
        name: "ventilation",
        redirect: "/hangzhouwan/ventilation/northChannel",
        component: emptyComponent,
        children: [
          {
            path: "northChannel",
            name: "hangzhouwanVentilationNorthChannel",
            component: ventilation
          },
          {
            path: "southChannel",
            name: "hangzhouwanVentilationSouthChannel",
            component: ventilation
          },
        ]
      },
      {
        path: "ramp",
        name: "ramp",
        redirect: "/hangzhouwan/ramp/A1",
        component: emptyComponent,
        children: [
          {
            path: "A1",
            name: "hangzhouwanRampA1",
            component: ramp
          },
          {
            path: "A2",
            name: "hangzhouwanRampA2",
            component: ramp
          },
          {
            path: "B1",
            name: "hangzhouwanRampB1",
            component: ramp
          },
          {
            path: "B2",
            name: "hangzhouwanRampB2",
            component: ramp
          },
          {
            path: "B3",
            name: "hangzhouwanRampB3",
            component: ramp
          },
          {
            path: "B4",
            name: "hangzhouwanRampB4",
            component: ramp
          },
          {
            path: "C1",
            name: "hangzhouwanRampC1",
            component: ramp
          },
          {
            path: "C2",
            name: "hangzhouwanRampC2",
            component: ramp
          },
          {
            path: "C3",
            name: "hangzhouwanRampC3",
            component: ramp
          },
          {
            path: "C4",
            name: "hangzhouwanRampC4",
            component: ramp
          },
          {
            path: "D1",
            name: "hangzhouwanRampD1",
            component: ramp
          },
          {
            path: "D2",
            name: "hangzhouwanRampD2",
            component: ramp
          },
          {
            path: "D3",
            name: "hangzhouwanRampD3",
            component: ramp
          },
          {
            path: "D4",
            name: "hangzhouwanRampD4",
            component: ramp
          },
          {
            path: "E1",
            name: "hangzhouwanRampE1",
            component: ramp
          },
          {
            path: "E2",
            name: "hangzhouwanRampE2",
            component: ramp
          },
          {
            path: "E3",
            name: "hangzhouwanRampE3",
            component: ramp
          },
          {
            path: "E4",
            name: "hangzhouwanRampE4",
            component: ramp
          }
        ]
      },
      {
        path: 'bridgeImg',
        name: 'bridgeImg',
        component: bridgeImg
      },
    ]
  }
];
